<mat-card>
  <div class="flex items-center gap-2 p-2">
    <form (ngSubmit)="onSearch()" [formGroup]="form" class="flex-auto">
      <mat-form-field class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'catalog.search_form_simple.label' | transloco }}</mat-label>
        <input (input)="onInputChange($event)" formControlName="query" matInput>

        @if (hasVirtualKeyboard) {
          <button
            (click)="onKeyboardOpenToggle()"
            mat-icon-button
            matPrefix
            type="button"
          >
            <mat-icon>keyboard</mat-icon>
          </button>
        }

        @if (form.value.query) {
          <button
            (click)="onClearInput()"
            class="mx-1"
            mat-icon-button
            matSuffix
            type="button"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </form>

    <button (click)="onSearch()" [disabled]="form.invalid" mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>

    <cat-search-form-mode-button (modeChange)="onModeChange($event)"
                                 [mode]="searchFormMode$ | async"></cat-search-form-mode-button>
  </div>
</mat-card>
